
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/inbox/[[...conversationId]]",
      function () {
        return require("private-next-pages/a/inbox/[[...conversationId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/inbox/[[...conversationId]]"])
      });
    }
  